import { CreateTaxonomyRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_TENANT_TAXONOMY_QUERY_KEY } from './useGetTenantTaxonomy';

export const useCreateTaxonomy = () => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { mutate, isPending, error } = useMutation({
    mutationFn: (data: CreateTaxonomyRequest) => api.taxonomy.createTaxonomy(tenantId, data),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: [GET_TENANT_TAXONOMY_QUERY_KEY],
        exact: false,
      });
    },
  });

  return {
    createTaxonomy: mutate,
    isCreating: isPending,
    createError: getApiError(error),
  };
};
